import React, { Fragment } from "react";
import {
  Page,
  Document,
  StyleSheet,
  View,
  Text,
  Image,
  pdf,
} from "@react-pdf/renderer";
import ppkmLogo from "../images/PPKM_Logo.png";

interface PDFProps {
  data: any;
}

// Define styles for the PDF document
const styles = StyleSheet.create({
  page: {
    padding: 10,
    fontFamily: "Helvetica",
  },
  logo: {
    width: "3.0in",
    height: "0.70in",
    marginBottom: 10,
    alignSelf: "center",
  },
  title: {
    textAlign: "center",
    marginBottom: 10,
    fontSize: 15,
    fontWeight: "bold",
  },
  table: {
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
    marginBottom: 10,
    border: "collapse",
  },
  tableRow: {
    flexDirection: "row",
  },
  tableHeader: {
    backgroundColor: "#f0f0f0",
    fontWeight: "bold",
    padding: 8,
    textAlign: "center",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
  },
  tableCell: {
    padding: 6,
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
    textAlign: "left",
    fontSize: "12pt",
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 10,
  },
  footerNote: {
    fontSize: 10,
    marginTop: 20,
  },
});

// Define the PDF document component
const MyDocument: React.FC<PDFProps> = ({ data }) => {
  if (!data) return null;

  const IsCorporate = () => {
    return (
      data.member_type === "MTYPE-000001" || data.member_type === "MTYPE-000004"
    );
  };

  const getLabel = () => {
    if (data.member_type === "MTYPE-000001") return "CORPORATE";
    if (data.member_type === "MTYPE-000002") return "INDIVIDUAL";
    if (data.member_type === "MTYPE-000003") return "ASSSOCIATE";
    if (data.member_type === "MTYPE-000004") return "AFFILIATE CORPORATE";
    if (data.member_type === "MTYPE-000005") return "AFFILIATE INDIVIDUAL";
    return null;
  };

  const label = getLabel();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Logo */}
        <Image src={ppkmLogo} style={styles.logo} />

        {/* Title */}
        <Text style={styles.title}>MEMBERSHIP APPLICATION FORM</Text>

        {IsCorporate() ? (
          <Fragment>
            {/* Corporate Membership Section */}
            {/* COMPANY INFO */}
            <Text style={styles.sectionTitle}>{label} MEMBERSHIP</Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "35%" }]}>
                  Name of Company:
                </Text>
                <Text style={[styles.tableCell, { width: "65%" }]}>
                  {data.company_name}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "35%" }]}>
                  Date of Incorporation:
                </Text>
                <Text style={[styles.tableCell, { width: "65%" }]}>
                  {data.date_of_incorporation}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "35%" }]}>
                  Co. Registration No.:
                </Text>
                <Text style={[styles.tableCell, { width: "65%" }]}>
                  {data.company_number}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "35%" }]}>
                  Name of Building/Mall represented:
                </Text>
                <Text style={[styles.tableCell, { width: "65%" }]}>
                  {data.name_of_building}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "35%" }]}>
                  Website Address:
                </Text>
                <Text style={[styles.tableCell, { width: "65%" }]}>
                  {data.website}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "35%" }]}>
                  Telephone No:
                </Text>
                <Text style={[styles.tableCell, { width: "65%" }]}>
                  {data.company_telephone_number}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "35%" }]}>Email:</Text>
                <Text style={[styles.tableCell, { width: "65%" }]}>
                  {data.company_email}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "35%" }]}>
                  Gross Built Up Area (sq.ft.):
                </Text>
                <Text style={[styles.tableCell, { width: "65%" }]}>
                  {data.gross_built_up_area}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "35%" }]}>
                  Nett Lettable Area (sq.ft.):
                </Text>
                <Text style={[styles.tableCell, { width: "65%" }]}>
                  {data.nett_lettable_area}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "35%" }]}>
                  No. of Floor:
                </Text>
                <Text style={[styles.tableCell, { width: "65%" }]}>
                  {data.no_of_floor}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "35%" }]}>
                  No. of Car Park:
                </Text>
                <Text style={[styles.tableCell, { width: "65%" }]}>
                  {data.no_of_car_park}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "35%" }]}>
                  Co. TIN No.:
                </Text>
                <Text style={[styles.tableCell, { width: "65%" }]}>
                  {data.e_invoice_pin}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "35%" }]}>
                  Registered Address:
                </Text>
                <Text style={[styles.tableCell, { width: "65%" }]}>
                  {data.company_registered_address}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "35%" }]}>
                  Correspondence Address:
                </Text>
                <Text style={[styles.tableCell, { width: "65%" }]}>
                  {data.company_correspondence_address}
                </Text>
              </View>
            </View>
            {/* APPOINTED */}
            <Text style={styles.sectionTitle}>
              APPOINTED REPRESENTATIVE INFO
            </Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Full Name:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.appointed_representative_name}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  NRIC Number:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.appointed_representative_nric}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Date of Birth:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.appointed_representative_dob}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Office Tel. No:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.appointed_representative_office_tel_no}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  H/phone No:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.appointed_representative_hp_no}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>Email:</Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.appointed_representative_email}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Designation:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.appointed_representative_designation}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Nature of Work:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.appointed_representative_nature_of_work}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Number of Years With Company:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.appointed_representative_no_of_years_with_company}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Academic Qualification:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.appointed_representative_academic_qualification}
                </Text>
              </View>
            </View>
            {/* ALTERNATE */}
            <Text style={styles.sectionTitle}>
              ALTERNATE REPRESENTATIVE INFO
            </Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Full Name:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.alternate_representative_name}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  NRIC Number:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.alternate_representative_nric}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Date of Birth:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.alternate_representative_dob}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Office Tel. No:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.alternate_representative_office_tel_no}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  H/phone No:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.alternate_representative_hp_no}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>Email:</Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.alternate_representative_email}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Designation:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.alternate_representative_designation}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Nature of Work:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.alternate_representative_nature_of_work}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Number of Years With Company:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.alternate_representative_no_of_years_with_company}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Academic Qualification:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.alternate_representative_academic_qualification}
                </Text>
              </View>
            </View>
            {/* OTHER */}
            <Text style={styles.sectionTitle}>OTHER REPRESENTATIVE INFO</Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Full Name:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.others_name}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  NRIC Number:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.others_nric}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Date of Birth:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.others_dob}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Office Tel. No:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.others_office_tel_no}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  H/phone No:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.others_hp_no}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>Email:</Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.others_email}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Designation:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.others_designation}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Nature of Work:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.others_nature_of_work}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Number of Years With Company:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.others_no_of_years_with_company}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Academic Qualification:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.others_academic_qualification}
                </Text>
              </View>
            </View>
          </Fragment>
        ) : (
          <Fragment>
            {/* Individual/Associate/Affiliate Membership Section */}
            <Text style={styles.sectionTitle}>{label} MEMBERSHIP</Text>
            <View style={styles.table}>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Name in Full:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_name}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  NRIC Number:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_nric}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Date of Birth:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_dob}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Registered Address:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_registered_address}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Correspondence Address:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_correspondence_address}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Place of Employment:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_place_of_employment}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Office Address:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_office_address}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Office Tel. No:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_office_tel_no}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Mobile No:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_hp_no}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>Email:</Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_email}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Designation:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_designation}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Nature of Work:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_nature_of_work}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Number of Years With Present Employer:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_no_of_years_with_present_employer}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "100%" }]}>
                  Previous Employer(s):
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Period 1:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_previous_employment_period_1}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Designation 1:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_previous_employment_designation_1}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Period 2:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_previous_employment_period_2}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Designation 2:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_previous_employment_designation_2}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Academic Qualifications:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_academic_qualification}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Other Academic Qualifications:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_other_academic_qualification}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Tertiary/Professional:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.individual_tertiary_professional}
                </Text>
              </View>
              <View style={styles.tableRow}>
                <Text style={[styles.tableCell, { width: "40%" }]}>
                  Individual TIN No.:
                </Text>
                <Text style={[styles.tableCell, { width: "60%" }]}>
                  {data.e_invoice_pin}
                </Text>
              </View>
            </View>
          </Fragment>
        )}

        {/* Declaration Section */}
        {/* <View style={{ marginBottom: 20 }}>
              <Text>
                We/I confirm that the above information is true and accurate and
                hereby abide by the Rules and Constitution of PPK Malaysia.
              </Text>
              <Text>
                Enclosed herewith is our cheque no: ..............for the sum of RM
                ...................payable to Persatuan Pengurusan Kompleks Malaysia
                (PPK) for the entrance and subscription fees for Year:
                ...................
              </Text>
              <Text>
                Date this ..........................day of
                ........................year ...........................
              </Text>
            </View> */}

        {/* Signature Section */}
        {/* <View style={{ marginBottom: 20 }}>
              <Text>
                .....................................................................
              </Text>
              <Text>
                Authorised Signatory of Corporate Representative/Individual*
              </Text>
              <Text>
                ..............................................................
              </Text>
              <Text>....................................................</Text>
              <Text>Name & Designation Company's Stamp</Text>
            </View> */}

        {/* Recommended By Section */}
        {/* <View style={{ marginBottom: 20 }}>
              <Text style={{ fontWeight: "bold" }}>RECOMMENDED BY:</Text>
              <Text>Name: .....................................................</Text>
              <Text>Contact details: .......................................</Text>
              <Text>
                .....................................................................
              </Text>
              <Text>..........................................................</Text>
              <Text>
                .....................................................................
              </Text>
            </View> */}

        {/* For Official Use Section */}
        {/* <View style={{ marginBottom: 20 }}>
              <Text style={{ fontWeight: "bold" }}>For Official Use</Text>
              <Text>Date Received:</Text>
              <Text>Remarks:</Text>
              <Text>Date of Approval of Membership/Membership No:</Text>
              <Text>Checked by:</Text>
            </View> */}

        {/* Footer Notes */}
        {/* <View style={styles.footerNote}>
              <Text>* Please indicate where applicable</Text>
              <Text>***PERSONAL DATA PROTECTION ACT (PDPA) CONSENT FORM</Text>
              <Text>
                At PPK Malaysia, we respect the privacy of individuals and the use of
                their personal data according to the PDPA.
              </Text>
              <Text>
                Personal data could be your name, contact details and any other data
                which we may obtain from you for the purpose of processing your
                membership application with our organization. Please rest assured that
                we will take reasonable care and precaution to prevent the loss or
                misuse of your Personal Information.
              </Text>
              <Text>
                The processing of your Personal Information is also subject to
                applicable laws. The Personal Information which you provide to us now
                or from time to time or have provided to us previously will be used
                and processed, and continued to be used and processed by us, in
                accordance with this Privacy Policy (as amended, varied or revised
                from time to time).
              </Text>
              <Text>
                By submitting the said information to us herein, we trust you have no
                objections to the processing of your personal data by our organization
                in accordance with the PDPA.
              </Text>
              <Text>Thank you.</Text>
            </View> */}
      </Page>
    </Document>
  );
};

// const PDFPreviewButton = () => {
//   const handlePreview = async () => {
//     // Generate the PDF blob
//     const blob = await pdf(<MyDocument />).toBlob();
//     // Create a URL for the blob
//     const url = URL.createObjectURL(blob);
//     // Open the PDF in a new tab
//     window.open(url, "_blank");
//     // Revoke the URL after some time to free memory
//     setTimeout(() => URL.revokeObjectURL(url), 1000);
//   };

//   return (
//     <button
//       onClick={handlePreview}
//       style={{
//         padding: "10px 20px",
//         backgroundColor: "#4CAF50",
//         color: "white",
//         border: "none",
//         borderRadius: "4px",
//         cursor: "pointer",
//       }}
//     >
//       Preview PDF
//     </button>
//   );
// };

// Export the component for use in your application
export default MyDocument;
